import type { QuotaRepository } from '../repository';

export type NotifyAdminUseCase = () => Promise<void>;

export const makeNotifyAdminUseCase =
  (repository: QuotaRepository): NotifyAdminUseCase =>
  async () =>
    repository.notifyAdmin();
